module.exports = __webpack_public_path__ + "static/img/200278.4c66b14b.png";